import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { H6 } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";
import { USER_ADDRESS_DATA, USER_PROFILE_DATA } from "../../../../Data/Users";

export const InfoSection = () => {
  return (
    <Row className="g-3">
      <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
        <Row className="g-3">
          {USER_PROFILE_DATA.map(({ iconClass, text, spanText }, index) => (
            <Col md="6" key={index}>
              <div className="ttl-info text-start">
                <H6 className="mb-1"><i className={`fa fa-${iconClass} me-2`}></i>{text}</H6>
                <span>{spanText}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
      <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
        <div className="user-designation">
          <div className="title">
            <Link target="_blank" to={Href}>Mark jecno</Link>
          </div>
          <div className="desc">designer</div>
        </div>
      </Col>
      <Col sm="6" xl="4" className="order-sm-2 order-xl-2">
        <Row className="g-3">
          {USER_ADDRESS_DATA.map(({ iconClass, text, spanText }, index) => (
            <Col md="6" key={index}>
              <div className="ttl-info text-start">
                <H6 className="mb-1"><i className={`fa fa-${iconClass}`}></i>{text}
                </H6>
                <span>{spanText}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};